import React from "react";
import {
    PolarAngleAxis,
    RadialBarChart, RadialBar, Label
} from "recharts";

const MetaChartGrid = (props) => {

   const titulo = props.titulo? props.titulo : 'META';
   const valor = props.valor? props.valor : 50;
   const meta = props.meta? props.meta  : 100;
   const width = props.width? props.width : 300;
   const height = props.height? props.height : 300;
   const unidadeValor = props.unidadeValor? props.unidadeValor : '';


    const data = [{
        name: {titulo},
        valor: valor,
        fill: '#fecc00'
    }];

    return(
        <RadialBarChart
            width={width}
            height={height}
            innerRadius="70%"
            outerRadius="90%"
            data={data}
            startAngle={90}
            endAngle={-180}
        >
            <PolarAngleAxis
                type="number"
                domain={[0, meta]}
                angleAxisId={0}
                tick={false}
            />
            <RadialBar minAngle={0} isAnimationActive={false}
                       background clockWise={true} dataKey='valor'/>
            <text
                x={width / 4}
                y={height / 4}
                textAnchor="middle"
                dominantBaseline="middle"
                className="progress-label"
            >
                {titulo}
            </text>
            <text
                x={width / 2}
                y={height / 2}
                textAnchor="middle"
                dominantBaseline="middle"
                fontSize="30px"
            >
                {valor}{unidadeValor}
            </text>

        </RadialBarChart>
    );
}

export default MetaChartGrid;